import { CACHE_KEYS } from '@/constants/cache-keys';
import { EngineService } from '@/services/engine';
import type { PersonOccurrence } from '@/types/person';
import { useOccurrences } from './useOccurrences';

interface UsePersonOccurrencesParams {
    personId: string | undefined;
    pageSize?: number;
}

export function usePersonOccurrences({
    personId,
    pageSize,
}: UsePersonOccurrencesParams) {
    return useOccurrences<PersonOccurrence>({
        entityId: personId,
        cacheKeyPrefix: CACHE_KEYS.PERSON_OCCURRENCES_PREFIX,
        fetcher: (id, params) => EngineService.getPersonOccurrences(id, params),
        pageSize,
    });
}
